import JSEncrypt from "jsencrypt";
import { getIdCardRsaKey } from "../api/index.js";

function normalizeHex(value) {
  return String(value || "").replace(/\s/g, "");
}

function padExponentHex(hex) {
  let value = normalizeHex(hex);
  if (value.length % 2 === 1) {
    value = "0" + value;
  }
  if (value.length < 6) {
    value = value.padStart(6, "0");
  }
  return value.toUpperCase();
}

function padModulusHex(hex) {
  let value = normalizeHex(hex);
  if (value.length % 2 === 1) {
    value = "0" + value;
  }
  if (value.length < 256) {
    value = value.padStart(256, "0");
  }
  return value.toUpperCase();
}

export async function createIdCardRsaSession() {
  const res = await getIdCardRsaKey();
  if (!res || res.state !== "success" || !res.data) {
    throw new Error((res && res.message) || "加密组件初始化失败");
  }
  const data = res.data;
  const rsaKey = data.RsaKey || data.rsaKey;
  const serverPublic1 = data.ServerPublic1 || data.serverPublic1;
  const serverPublic2 = data.ServerPublic2 || data.serverPublic2;
  if (!rsaKey || !serverPublic1 || !serverPublic2) {
    throw new Error("加密组件初始化失败");
  }
  const crypt = new JSEncrypt({ default_key_size: 1024 });
  const key = crypt.getKey();
  if (!key) {
    throw new Error("RSA密钥初始化失败");
  }
  key.setPublic(padModulusHex(serverPublic2), padExponentHex(serverPublic1));
  return {
    rsaKey: rsaKey,
    crypt: crypt,
  };
}

export function encryptIdCard(idCard, rsaSession) {
  if (!idCard || !rsaSession || !rsaSession.crypt) {
    throw new Error("身份证号加密参数无效");
  }
  const encrypted = rsaSession.crypt.encrypt(String(idCard).trim().toUpperCase());
  if (!encrypted) {
    throw new Error("身份证号加密失败");
  }
  return encrypted;
}

export function buildEncryptedIdCardPayload(idCard, rsaSession, routeKey) {
  return {
    RouteKey: routeKey,
    EncryptedIDCard: encryptIdCard(idCard, rsaSession),
    RsaKey: rsaSession.rsaKey,
  };
}



// WEBPACK FOOTER //
// ./src/utils/idCardCrypto.js